@if (phaseType(); as type) {
  <span class="mx-1 text-center"><span class="badge rounded-pill align-text-bottom"
                                       [ngClass]="'text-bg-' + type">{{ phase() | startCase }}</span></span>
}
